import { envDef, firebaseConfig } from 'src/environments/env.default';

export const environment = {
    ...envDef,
    prefix: 'eigreja',
    version: '14.0.19',
    urlAPI: 'https://eigreja.prod.api.gestor.ladder.dev.br',
    urlBase: 'eigreja.app',
    CrossDomainStorageOrigin: 'https://eigreja.prod.api.gestor.ladder.dev.br',
    firebase: firebaseConfig
};
